import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { header } from "./header";
import { modReportsHub_template } from "../components/templates/modReportsHub_template";

export class mod_reports_hub extends vnModule_knockoutJS {

    protected elementsList: modReportsHub_template;

    protected getModuleName(): string {
        return "mod_reports_hub";
    }

    buildContent(): Array<Element> {
        this.elementsList = new modReportsHub_template("hub", this.viewModel, this);
        this.template = this.elementsList;

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        if (loadedModule) {
            (<header>loadedModule).setHeaderTitle("Mod Reports");
        }

        return [this.elementsList.build()];
    }

    public fillPage(): void {
    }
}



// WEBPACK FOOTER //
// ./js/modules/mod_reports_hub.ts